const AboutContent = () => {
  return (
    <div className="min-h-screen text-white py-16 px-4 sm:px-8 md:px-16">
      <div className="max-w-6xl mx-auto">
        <h1 className="text-4xl md:text-5xl font-bold mb-8 text-center">
          About Carbon
        </h1>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          <div className="space-y-6">
            <h2 className="text-2xl md:text-3xl font-semibold text-purple-400">
              Our Vision
            </h2>
            <p className="text-gray-300 leading-relaxed">
              At Carbon, we are dedicated to redefining luxury automotive
              excellence. Our commitment to crafting exceptional vehicles
              combines cutting-edge technology with unparalleled design,
              creating automobiles that transcend ordinary transportation to
              become works of art.
            </p>
          </div>

          <div className="space-y-6">
            <h2 className="text-2xl md:text-3xl font-semibold text-blue-400">
              Our Mission
            </h2>
            <p className="text-gray-300 leading-relaxed">
              To create and deliver the world's most prestigious luxury vehicles
              while providing an innovative online and in-store purchasing
              experience that matches the excellence of our automobiles.
            </p>
          </div>
        </div>

        <div className="mt-16 space-y-8">
          <h2 className="text-2xl md:text-3xl font-semibold text-center text-orange-400">
            Why Choose Carbon?
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-gray-800 p-6 rounded-lg">
              <h3 className="text-xl font-semibold mb-4">Exclusive Models</h3>
              <p className="text-gray-300">
                Discover our collection of meticulously crafted luxury vehicles,
                each designed to deliver unprecedented performance and style.
              </p>
            </div>

            <div className="bg-gray-800 p-6 rounded-lg">
              <h3 className="text-xl font-semibold mb-4">Seamless Purchase</h3>
              <p className="text-gray-300">
                Experience our streamlined buying process, whether online or in
                our luxury showrooms, tailored to your preferences.
              </p>
            </div>

            <div className="bg-gray-800 p-6 rounded-lg">
              <h3 className="text-xl font-semibold mb-4">Premium Service</h3>
              <p className="text-gray-300">
                Our dedicated team of luxury automotive experts ensures
                personalized attention throughout your ownership journey.
              </p>
            </div>
          </div>
        </div>

        <div className="mt-16 text-center">
          <p className="text-gray-300 max-w-3xl mx-auto">
            Step into the world of automotive excellence with Carbon. We're not
            just selling cars; we're crafting experiences that define luxury,
            performance, and sophistication in the modern era.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutContent;
